export default __webpack_public_path__ + "static/media/105.af8fa876.png";